import React, { useEffect, useState } from 'react';
import {
  getAprobReglas, crearAprobRegla, editarAprobRegla, eliminarAprobRegla,
  getAprobaciones, resolverAprobacion,
} from '../services/api';

const DOCS = [['orden_compra', 'Orden de compra'], ['factura', 'Factura'], ['cotizacion', 'Cotización'], ['gasto', 'Gasto']];
const DOC_LBL = Object.fromEntries(DOCS);
const fmt = (n) => '$' + Number(n || 0).toLocaleString('es-CO');
const fdate = (d) => d ? new Date(d).toLocaleDateString('es-CO') : '—';
const REGLA0 = { documento: 'orden_compra', monto_desde: 0, aprobador_nombre: '' };

export default function Aprobaciones() {
  const [tab, setTab] = useState('pendientes');
  const [reglas, setReglas] = useState([]);
  const [pend, setPend] = useState([]);
  const [modal, setModal] = useState(false);
  const [fr, setFr] = useState(REGLA0);
  const [err, setErr] = useState('');

  const load = () => { getAprobReglas().then(r => setReglas(r.data)).catch(() => {}); getAprobaciones('pendiente').then(r => setPend(r.data)).catch(() => {}); };
  useEffect(() => { load(); }, []);

  const saveRegla = async () => {
    try { fr.id ? await editarAprobRegla(fr.id, fr) : await crearAprobRegla(fr); setModal(false); load(); }
    catch (e) { setErr(e.response?.data?.error || 'Error'); }
  };
  const delRegla = async (x) => { if (window.confirm('¿Eliminar la regla?')) { await eliminarAprobRegla(x.id); load(); } };
  const resolver = async (a, accion) => {
    const comentario = accion === 'rechazar' ? (window.prompt('Motivo del rechazo (opcional):') || '') : '';
    try { await resolverAprobacion(a.id, { accion, comentario }); load(); }
    catch (e) { alert(e.response?.data?.error || 'Error'); }
  };

  return (
    <div>
      <div style={s.header}><div><h1 style={s.h1}>Flujos de aprobación</h1><p style={s.sub}>Reglas y aprobaciones pendientes de documentos</p></div>
        {tab === 'reglas' && <button style={s.btnPrimary} onClick={() => { setErr(''); setFr(REGLA0); setModal(true); }}>+ Nueva regla</button>}
      </div>

      <div style={s.tabs}>
        <button style={{ ...s.tab, ...(tab === 'pendientes' ? s.tabOn : {}) }} onClick={() => setTab('pendientes')}>Pendientes ({pend.length})</button>
        <button style={{ ...s.tab, ...(tab === 'reglas' ? s.tabOn : {}) }} onClick={() => setTab('reglas')}>Reglas ({reglas.length})</button>
      </div>

      {tab === 'pendientes' ? (
        <div style={s.card}><table style={s.table}>
          <thead><tr>{['Documento', 'Referencia', 'Monto', 'Solicitado', 'Acciones'].map(h => <th key={h} style={s.th}>{h}</th>)}</tr></thead>
          <tbody>
            {pend.length === 0 && <tr><td colSpan={5} style={s.empty}>No hay aprobaciones pendientes. 🎉</td></tr>}
            {pend.map(a => (
              <tr key={a.id}>
                <td style={s.td}><span style={s.chip}>{DOC_LBL[a.documento] || a.documento}</span></td>
                <td style={{ ...s.td, color: '#e2e8f0', fontWeight: 600 }}>{a.referencia || '—'}</td>
                <td style={{ ...s.td, fontWeight: 700 }}>{fmt(a.monto)}</td>
                <td style={s.td}>{fdate(a.created_at)}</td>
                <td style={s.td}>
                  <button style={{ ...s.btnSm, background: '#166534', color: '#bbf7d0' }} onClick={() => resolver(a, 'aprobar')}>✓ Aprobar</button>
                  <button style={{ ...s.btnSm, background: '#7f1d1d', color: '#fecaca', marginLeft: 6 }} onClick={() => resolver(a, 'rechazar')}>✕ Rechazar</button>
                </td>
              </tr>
            ))}
          </tbody>
        </table></div>
      ) : (
        <div style={s.card}><table style={s.table}>
          <thead><tr>{['Documento', 'Aplica desde', 'Aprobador', 'Acciones'].map(h => <th key={h} style={s.th}>{h}</th>)}</tr></thead>
          <tbody>
            {reglas.length === 0 && <tr><td colSpan={4} style={s.empty}>Sin reglas. Crea una para exigir aprobación por monto.</td></tr>}
            {reglas.map(r => (
              <tr key={r.id}>
                <td style={s.td}><span style={s.chip}>{DOC_LBL[r.documento] || r.documento}</span></td>
                <td style={{ ...s.td, fontWeight: 700 }}>{fmt(r.monto_desde)}</td>
                <td style={s.td}>{r.aprobador_nombre || 'Cualquier administrador'}</td>
                <td style={s.td}><button style={s.link} onClick={() => { setErr(''); setFr({ ...REGLA0, ...r }); setModal(true); }}>Editar</button>
                  <button style={{ ...s.link, color: '#fca5a5' }} onClick={() => delRegla(r)}>Eliminar</button></td>
              </tr>
            ))}
          </tbody>
        </table>
        <p style={s.nota}>Cuando se crea un documento cuyo total sea ≥ "Aplica desde", el sistema genera automáticamente una solicitud de aprobación que aparece en la pestaña "Pendientes". (Hoy activo para órdenes de compra.)</p>
        </div>
      )}

      {modal && (
        <div style={s.overlay}><div style={s.modal}>
          <div style={s.modalHeader}><h2 style={s.modalTitle}>{fr.id ? 'Editar regla' : 'Nueva regla de aprobación'}</h2><button style={s.closeBtn} onClick={() => setModal(false)}>✕</button></div>
          <div style={s.modalBody}>
            <div style={s.field}><label style={s.label}>Documento</label>
              <select style={s.input} value={fr.documento} onChange={e => setFr({ ...fr, documento: e.target.value })}>{DOCS.map(([v, l]) => <option key={v} value={v}>{l}</option>)}</select></div>
            <div style={s.field}><label style={s.label}>Requiere aprobación cuando el total sea ≥</label>
              <input style={s.input} type="number" value={fr.monto_desde} onChange={e => setFr({ ...fr, monto_desde: e.target.value })} /></div>
            <div style={s.field}><label style={s.label}>Aprobador (etiqueta, opcional)</label>
              <input style={s.input} value={fr.aprobador_nombre || ''} placeholder="Ej: Gerencia" onChange={e => setFr({ ...fr, aprobador_nombre: e.target.value })} /></div>
            {err && <div style={s.error}>{err}</div>}
          </div>
          <div style={s.modalFooter}><button style={s.btnSecondary} onClick={() => setModal(false)}>Cancelar</button><button style={s.btnPrimary} onClick={saveRegla}>Guardar</button></div>
        </div></div>
      )}
    </div>
  );
}

const s = {
  header: { display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: 16 },
  h1: { fontSize: 24, fontWeight: 700, color: '#f1f5f9', margin: 0 },
  sub: { color: '#64748b', fontSize: 14, margin: '4px 0 0' },
  btnPrimary: { background: '#1d4ed8', color: '#fff', border: 'none', borderRadius: 8, padding: '10px 18px', fontSize: 14, fontWeight: 600, cursor: 'pointer' },
  btnSecondary: { background: '#334155', color: '#cbd5e1', border: 'none', borderRadius: 8, padding: '10px 18px', fontSize: 14, cursor: 'pointer' },
  btnSm: { border: 'none', borderRadius: 6, padding: '5px 10px', fontSize: 12, fontWeight: 600, cursor: 'pointer' },
  tabs: { display: 'flex', gap: 8, marginBottom: 16, borderBottom: '1px solid #334155' },
  tab: { background: 'none', border: 'none', color: '#94a3b8', padding: '10px 16px', fontSize: 14, cursor: 'pointer', borderBottom: '2px solid transparent' },
  tabOn: { color: '#f1f5f9', borderBottom: '2px solid #4f46e5', fontWeight: 600 },
  card: { background: '#1e293b', border: '1px solid #334155', borderRadius: 12, overflow: 'hidden' },
  table: { width: '100%', borderCollapse: 'collapse', fontSize: 13 },
  th: { background: '#0f172a', color: '#94a3b8', fontSize: 11, textTransform: 'uppercase', letterSpacing: '.5px', padding: '10px 14px', textAlign: 'left' },
  td: { padding: '10px 14px', color: '#cbd5e1', borderBottom: '1px solid #1a2332' },
  empty: { padding: 24, textAlign: 'center', color: '#64748b' },
  chip: { fontSize: 11, background: '#334155', color: '#cbd5e1', padding: '2px 8px', borderRadius: 4 },
  link: { background: 'none', border: 'none', color: '#60a5fa', cursor: 'pointer', fontSize: 13, padding: 0, marginRight: 12 },
  nota: { color: '#64748b', fontSize: 12, padding: '10px 14px', margin: 0 },
  overlay: { position: 'fixed', inset: 0, background: 'rgba(0,0,0,.6)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 50, padding: 16 },
  modal: { background: '#1e293b', borderRadius: 16, width: '92%', maxWidth: 480, border: '1px solid #334155', display: 'flex', flexDirection: 'column' },
  modalHeader: { display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '18px 22px', borderBottom: '1px solid #334155' },
  modalTitle: { color: '#f1f5f9', fontSize: 18, fontWeight: 700, margin: 0 },
  closeBtn: { background: 'none', border: 'none', color: '#94a3b8', fontSize: 20, cursor: 'pointer' },
  modalBody: { padding: '18px 22px' },
  modalFooter: { display: 'flex', justifyContent: 'flex-end', gap: 10, padding: '14px 22px', borderTop: '1px solid #334155' },
  field: { display: 'flex', flexDirection: 'column', gap: 4, marginBottom: 12 },
  label: { color: '#94a3b8', fontSize: 12 },
  input: { background: '#0f172a', border: '1px solid #334155', borderRadius: 8, height: 40, padding: '0 11px', color: '#f1f5f9', fontSize: 13, width: '100%', boxSizing: 'border-box' },
  error: { background: '#450a0a', border: '1px solid #b91c1c', color: '#fca5a5', padding: '8px 12px', borderRadius: 8, marginTop: 8, fontSize: 13 },
};
